import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['switch', 'input']
  static values = { 
    default: String,
    unchecked: String
  }

  connect() {
    // Small delay to ensure Choices.js has initialized first
    setTimeout(() => {
      this.updateInputState()
    }, 100)
  }

  toggle() {
    this.updateInputState()
  }

  updateInputState() {
    const isEnabled = this.switchTarget.checked
    this.inputTargets.forEach(input => {
      if (isEnabled) {
        if (input.choicesInstance) {
          input.choicesInstance.enable();
        } else {
          input.disabled = false
        }
        
        if (this.hasDefaultValue && (!input.value || input.value === '' || input.value === 'null' || input.value === this.uncheckedValue)) {
          input.value = this.defaultValue
        }
      } else {
        if (input.choicesInstance) {
          input.choicesInstance.disable();
        } else {
          input.disabled = true
        }
        
        if (this.hasUncheckedValue && input.value !== this.uncheckedValue) {
          input.value = this.uncheckedValue
        }
      }
    })
  }
}
